import React, { useState } from "react";
import {
  addDoc,
  arrayUnion,
  collection,
  doc,
  serverTimestamp,
  Timestamp,
  updateDoc,
} from "firebase/firestore";
import { v4 as uuid } from "uuid";
import { useSelector } from "react-redux";
import { SelectUser } from "../../../../store/usersSlice";
import { SelectChatUser } from "../../../../store/chatUserSlice";
import { db } from "../../../../firebase";
import { Button, Input, Layout } from "antd";
import { SendOutlined } from "@ant-design/icons";
const { Footer } = Layout;

const MessageInput = ({isAllUserChatShown, setReloadMessages, reloadMessages}) => {
  const [text, setText] = useState("");

  const currentUser = useSelector(SelectUser);
  const data = useSelector(SelectChatUser);
  console.log("dispatched user data", data);

  const handleSend = async () => {
    if(isAllUserChatShown){
      const chatsRef = collection(db, "companies", currentUser?.companyName, "allUserChats");
      addDoc(chatsRef,
        {
            id: uuid(),
            text,
            senderId: currentUser.uid,
            date: Timestamp.now()
        }
      );
      setReloadMessages(!reloadMessages);
      setText("");
    }
    else{
      await updateDoc(
        doc(db, "companies", currentUser?.companyName, "chats", data.chatId),
        {
          messages: arrayUnion({
            id: uuid(),
            text,
            senderId: currentUser.uid,
            date: Timestamp.now(),
          }),
        }
      );
  
      await updateDoc(
        doc(
          db,
          "companies",
          currentUser?.companyName,
          "userChats",
          currentUser.uid
        ),
        {
          [data.chatId + ".lastMessage"]: {
            text,
          },
          [data.chatId + ".date"]: serverTimestamp(),
        }
      );
  
      await updateDoc(
        doc(
          db,
          "companies",
          currentUser?.companyName,
          "userChats",
          data.user.uid
        ),
        {
          [data.chatId + ".lastMessage"]: {
            text,
          },
          [data.chatId + ".date"]: serverTimestamp(),
        }
      );
  
      setText("");
    }
   
  };
  const handleInputKeyPress = (e) => {
    if (e.key === "Enter") {
      setText(e.target.value);
    }
  };
  return (
    <Footer
      style={{
        backgroundColor: "white",
        border: "1px solid silver",
        borderLeft: "none",
        padding: 0,
        borderRadius: "0px 0px 10px 0px",
      }}
    >
      <div className="footer-input-container">
        <Input
          className="input-message"
          placeholder="Type your message"
          value={text}
          onChange={(e) => setText(e.target.value)}
          onKeyPress={handleInputKeyPress}
        />
        <Button className="send-button" type="primary" onClick={()=>handleSend()}>
          <SendOutlined className="send-icon" /> Send{" "}
          {/* Replace Send icon with the actual icon component */}
        </Button>
      </div>
    </Footer>
  );
};

export default MessageInput;
